import { useMemo } from "react";
import type { JsonSchema } from "@jsonforms/core";
import { createCatalogErrorTranslator } from "../utils/catalogValidationMessages";

export function useCatalogValidationI18n(schema: JsonSchema, data: unknown) {
  return useMemo(() => ({ translateError: createCatalogErrorTranslator(schema, data) }), [schema, data]);
}
